import api from '../../api';
// 获取产品列表
export function getProductList(params) {
  return api.post('/product/getProductList.go', params, false, false).then(res => res);
}
// 新增产品
export function addProduct(params) {
  return api.post('/product/addProduct.go', params).then(res => res);
}
// 获取产品详情
export function getProduct(params) {
  return api.post('/product/getProduct.go', params, false, false).then(res => res);
}
// 更新产品详情
export function upProduct(params) {
  return api.post('/product/upProduct.go', params).then(res => res);
}
// 产品删除
export function delProduct(params) {
  return api.post('/product/delProduct.go', params).then(res => res);
}
// 产品隐藏
export function hideProduct(params) {
  return api.post('/product/hideProduct.go', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/product.js